'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = isString;
function isString(maybe) {
    return typeof maybe === 'string';
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-custom-scrollbars/lib/utils/isString.js
 ** module id = 1748
 ** module chunks = 3
 **/